module.exports = __webpack_public_path__ + "img/yesterday.be5030ca.webp";